<template>
    <div v-bind:class="listClass">
        <v-container fluid>
            <v-row dense class="campaign-list">
                <listElement v-if="add === true"
                             :campaign="placeholderData"
                             :view-privilege="true"
                             :edit-privilege="false"
                             :delete-privilege="false"
                             :small="true"
                             mode="tiles"
                             key="placeholder"
                             :element-class="elementClass"
                             :drag-drop="true">
                </listElement>

                <template v-for="(campaign, key) in campaigns">
                    <listElement :campaign="campaign"
                                 :view-privilege="true"
                                 :edit-privilege="false"
                                 :delete-privilege="false"
                                 :small="true"
                                 mode="tiles"
                                 :key="key"
                                 :element-class="elementClass"
                                 :drag-drop="true">
                    </listElement>
                </template>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import listElement from "./campaignElementTile.vue";

    export default {
        props: [
            'campaigns',
            'classes',
            'elementClass',
            'add'
        ],
        components: {
            listElement,
        },
        computed: {
            listClass: function () {
                return this.classes + ' col-md-12';
            },
        },
        data: function () {
            return {
                t_new: Lang.langGet("New"),
                t_validity: Lang.langGet("Validity"),
                t_added: Lang.langGet("Added"),
                t_modified: Lang.langGet("Modified"),
                placeholderData: {
                    first_revision_id: 0,
                    last_revision_id: 0,
                    last_preview: '',
                    is_placeholder: true,
                    parameters: {},
                    name: Lang.langGet("Create New"),
                    created_at: '',
                    updated_at: '',
                    tags: []
                }
            }
        },
    }
</script>
